import { DDStatuses } from 'utils/api/types';

export const formatDueDiligenceStatus = (status: DDStatuses | undefined) => {
  if (status === 'AWAITING_ASSESSMENT' || !status) {
    return 'Awaiting Assessment';
  }
  if (status === 'APPROVED') {
    return 'Approved';
  }
  if (status === 'DECLINED') {
    return 'Declined';
  }
};
